import React, { useEffect } from 'react';
import "./style.scss"
import MainBanner from './MainBanner';
import ProjectComponents from './ProjectComponents';
import WhyChooseUs from './WhyChooseUs';
// import Partner from './Partner';
import EventGoing from './EventGoing';
import Faqs from './faqs';
import OurCommunity from './OurCommunity';
import GetStarted from './GetStarted';

const HomePage = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        }, []);
        useEffect(() => {
            document.title = "Home | TinyBlock";
           }, []);
    return (
        <>
            <MainBanner />
            <ProjectComponents />
            <WhyChooseUs />
            {/* <Partner /> */}
            <EventGoing />
            <Faqs />
            <OurCommunity />
            <GetStarted />
        </>
    )
}
export default HomePage